// extracted by mini-css-extract-plugin
module.exports = {"root":"heading_root___Ii3X"};